import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { CachedPortfolioService } from '@cfp/core';
import { ReportBuildingsDownloadButton } from '@cfp/features-shared/portfolio-buildings-roadmap-report';
import { map, of, switchMap } from 'rxjs';

@Component({
  selector: 'cfp-lbg-report-buildings-download-button',
  templateUrl: 'lbg-report-buildings-download-button.html',
  imports: [ReportBuildingsDownloadButton],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LbgReportBuildingsDownloadButton {
  public readonly portfolioId = input.required<number>();

  private readonly cachedPortfolioService = inject(CachedPortfolioService);

  protected readonly fileName = toSignal(
    toObservable(this.portfolioId).pipe(
      switchMap((portfolioId) => {
        if (!portfolioId) {
          return of('retll-report.pdf');
        }
        return this.cachedPortfolioService
          .v2PortfoliosIdGet(portfolioId)
          .pipe(map((portfolio) => `${portfolio.name}-retll-report.pdf`));
      })
    ),
    { initialValue: 'retll-report.pdf' }
  );
}
